<template>
    <section>
        <uiModal
            name="new-flowr-subscription"
            title="Criar Fluxo de Assinatura"
            size="xs"
            @close="close"
        >
            <div class="content">
                <div class="title">Informe o nome do fluxo de assinatura:</div>
                <div>
                    <ui-input v-model="flowrName" maxlength="45" placeholder="Ex. Assinatura Contrato" />
                </div>
                <div class="type">
                    <ui-radio
                        name="sig-type"
                        label="Assinatura padrão"
                        value="8"
                        inline
                        @input="typeHandler"
                    />
                    <ui-radio
                        name="sig-type"
                        label="Assinatura invisível"
                        value="16"
                        inline
                        @input="typeHandler"
                    />
                </div>
            </div>
            <template #footer>
                <div class="save">
                    <ui-button :disabled="cantSubmit" design="success wsm" @click="create">
                        Avançar
                    </ui-button>
                </div>
            </template>
        </uiModal>
    </section>
</template>

<script>
	import { uiInput, uiRadio } from '@/components/ui/form'
	import { uiModal } from '@/components/ui/modal'
	import { uiButton } from '@/components/ui/buttons'

	const defaultParamsData = () => ({
		files: null,
		flowName: null,
		flowType: null,
		dealId: null,
	})

	export default {
		components: {
			uiInput,
			uiRadio,
			uiModal,
			uiButton,
		},

		data() {
			return {
				flowrName: '',
				flowrType: null,

				paramsData: { ...defaultParamsData() },
			}
		},

		computed: {
			cantSubmit() {
				return this.flowrName == '' || !this.flowrType
			},
		},

		mounted() {
			this.$root.$on('modal-open-new-flowr-subscription', () => {
				this.openIframe('closed-modal')
				this.getAllParams()
			})
		},

		beforeDestroy() {
			this.$root.$off('modal-open-new-flowr-subscription')
		},

		methods: {
			create() {
				// Emite o evento do Google Analytics
				this.$gtm.trackEvent({
					event: 'fac_button_click',
					category: 'vue-avancar',
					action: 'click',
					label: 'Avançar'
				})

				// Close the current modal
				this.$root.$emit('modal-close-new-flowr-subscription')

				// Open select signers modal
				this.selectSigners()
			},

			close() {
				// Emite o evento do Google Analytics
				this.$gtm.trackEvent({
					event: 'fac_button_click',
					category: 'vue-fechar-aba',
					action: 'click',
					label: 'Fechar Aba'
				})

				const event = new CustomEvent('iframe--request-modal')
				window.parent.document.dispatchEvent(event)
			},

			openIframe(value, data = null) {
				let event = new CustomEvent(`iframe--contracts-${value}`, { detail: data })
				window.parent.document.dispatchEvent(event)
			},

			selectSigners() {
				const data = {
					files: this.paramsData.files,
					flowName: this.flowrName,
					flowType: this.flowrType,
					dealId: this.paramsData.dealId,
				}

				this.openIframe('select', data)
			},

			getAllParams() {
				this.paramsData.files = this.$route.params.files
					? JSON.parse(this.$route.params.files)
					: null
				this.paramsData.dealId = this.$route.params.dealId
					? Number(this.$route.params.dealId)
					: null
			},
			/**
			 * Event handler que trata o evento de quando o tipo do Fluxo de Assinatura
			 * é selecionado
			 */
			typeHandler(type) {
				if (!type) return

				let category = ''
				let label = ''
				switch (type) {
					case "8":
						category = 'vue-assinatura-padrao'
						label = "Assinatura Padrao"
						break

					case "16":
						category = 'vue-assinatura-invisivel'
						label = "Assinatura Invisível"
						break
				}
				// Emite o evento do Google Analytics
				this.$gtm.trackEvent({ event: 'fac_button_click', category, action: 'click', label })

				this.flowrType = type
			},
		},
	}
</script>

<style lang="stylus" scoped>
	@import 'styles.styl'
</style>
